(function () {
  'use strict';

  var namespace = 'CurveaLiberte';

  function ensurePurchaseAnchor() {
    if (document.getElementById('curvea-liberte-achat')) return;
    var productForm = document.querySelector('main form[action*="/cart/add"]');
    if (!productForm) return;
    var productSection = productForm.closest('.shopify-section') || productForm.parentElement;
    if (!productSection || !productSection.parentNode) return;
    var anchor = document.createElement('span');
    anchor.id = 'curvea-liberte-achat';
    anchor.setAttribute('aria-hidden', 'true');
    anchor.style.cssText = 'display:block;position:relative;top:-16px;visibility:hidden;';
    productSection.parentNode.insertBefore(anchor, productSection);
  }

  function guardForeignRapiOffer() {
    if (!document.querySelector('.curvea-liberte')) return;

    document.querySelectorAll('.rapi-bundle-content-0').forEach(function (node) {
      if (!/Legging 3D Anti-Cellulite/i.test(node.textContent || '')) return;
      var form = node.closest('form');
      if (form) {
        form.setAttribute('data-cl-foreign-rapi', 'true');
        form.querySelectorAll('[name*="rapi"]').forEach(function (field) { field.remove(); });
        var quantity = form.querySelector('[name="quantity"]');
        if (quantity) quantity.value = '1';
      }
      node.remove();
    });
  }

  function initGallery(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-cl-gallery-thumb]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cl-gallery-panel]'));

    if (!buttons.length || !panels.length) return;

    function showPanel(targetId) {
      panels.forEach(function (panel) {
        panel.hidden = panel.id !== targetId;
      });

      buttons.forEach(function (button) {
        var isSelected = button.getAttribute('aria-controls') === targetId;
        button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        button.tabIndex = isSelected ? 0 : -1;
      });
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        showPanel(button.getAttribute('aria-controls'));
      });

      button.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var next = (index + direction + buttons.length) % buttons.length;
        buttons[next].focus();
        showPanel(buttons[next].getAttribute('aria-controls'));
      });
    });
  }

  function initProductForm(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    var select = root.querySelector('[data-cl-variant-select]');
    var price = root.querySelector('[data-cl-price]');
    var comparePrice = root.querySelector('[data-cl-compare-price]');
    var availability = root.querySelector('[data-cl-availability]');
    var submit = root.querySelector('[data-cl-submit]');
    var submitLabel = root.querySelector('[data-cl-submit-label]');
    var errorBox = root.querySelector('[data-cl-form-error]');

    if (!form || !select || !submit) return;

    var defaultButtonLabel = submitLabel ? submitLabel.textContent : 'Ajouter au panier';
    var unavailableLabel = root.getAttribute('data-unavailable-label') || 'Indisponible';

    function announceError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = !message;
      if (message) errorBox.focus();
    }

    function updateVariant() {
      var option = select.options[select.selectedIndex];
      if (!option) return;

      var available = option.getAttribute('data-available') === 'true';
      var compareLabel = option.getAttribute('data-compare-price-label') || '';

      if (price) price.textContent = option.getAttribute('data-price-label') || '';
      if (comparePrice) {
        comparePrice.textContent = compareLabel;
        comparePrice.hidden = !compareLabel;
      }
      if (availability) {
        availability.textContent = available ? availability.getAttribute('data-in-stock-label') : unavailableLabel;
        availability.setAttribute('data-available', available ? 'true' : 'false');
      }

      submit.disabled = !available;
      submit.setAttribute('aria-disabled', available ? 'false' : 'true');
      if (submitLabel) submitLabel.textContent = available ? defaultButtonLabel : unavailableLabel;
      announceError('');

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url.toString());
      }
    }

    select.addEventListener('change', updateVariant);
    updateVariant();

    if (!window.fetch || !window.FormData) return;

    form.addEventListener('submit', function (event) {
      if (submit.disabled) return;
      event.preventDefault();
      announceError('');

      var cartRenderer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var formData = new FormData(form);

      if (cartRenderer && typeof cartRenderer.getSectionsToRender === 'function') {
        var sections = cartRenderer.getSectionsToRender().map(function (section) {
          return section.id;
        });
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      if (submitLabel) submitLabel.textContent = root.getAttribute('data-adding-label') || 'Ajout en cours…';

      fetch(root.getAttribute('data-cart-add-url') || form.action, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok || payload.status) {
              throw new Error(payload.description || payload.message || 'Cette variante n’a pas pu être ajoutée.');
            }
            return payload;
          });
        })
        .then(function (payload) {
          if (cartRenderer && typeof cartRenderer.renderContents === 'function' && payload.sections) {
            cartRenderer.renderContents(payload);
            return;
          }

          document.dispatchEvent(new CustomEvent('curvea:cart:updated', {
            bubbles: true,
            detail: payload
          }));

          window.location.assign(root.getAttribute('data-cart-url') || '/cart');
        })
        .catch(function (error) {
          announceError(error.message || 'Une erreur est survenue. Vérifiez votre sélection puis réessayez.');
        })
        .finally(function () {
          var currentOption = select.options[select.selectedIndex];
          var available = currentOption && currentOption.getAttribute('data-available') === 'true';
          submit.disabled = !available;
          submit.setAttribute('aria-busy', 'false');
          if (submitLabel) submitLabel.textContent = available ? defaultButtonLabel : unavailableLabel;
        });
    });
  }

  function init(scope) {
    var context = scope || document;
    ensurePurchaseAnchor();
    context.querySelectorAll('[data-cl-gallery]').forEach(initGallery);
    context.querySelectorAll('[data-cl-product-root]').forEach(initProductForm);
  }

  window[namespace] = window[namespace] || { init: init };

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.getAttribute('data-cl-foreign-rapi') !== 'true') return;
    form.querySelectorAll('[name*="rapi"]').forEach(function (field) { field.remove(); });
    var quantity = form.querySelector('[name="quantity"]');
    if (quantity) quantity.value = '1';
  }, true);

  guardForeignRapiOffer();
  if (window.MutationObserver) {
    var foreignRapiObserver = new MutationObserver(guardForeignRapiOffer);
    foreignRapiObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      foreignRapiObserver.disconnect();
      guardForeignRapiOffer();
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
